// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--modal-padding-x: 1.5rem}.modal-content{border:none}.modal-header{border:none;padding:1rem var(--modal-padding-x) 1rem}.modal-header .close{font-size:2rem;font-weight:400;line-height:.75}.modal-body{padding:1rem var(--modal-padding-x)}.modal-footer{border:none;padding:1rem var(--modal-padding-x) 1rem}.modal-footer *{margin:0}.modal-backdrop{opacity:0.5}\n", ""]);
// Exports
module.exports = exports;
